const AGENT_URL = window._env_?.REACT_APP_TEMPLATE_AGENT_URL || 'http://localhost:8001';

export const financialSummaryApi = {
  // SSE stream
  streamChat: (body, signal) => fetch(`${AGENT_URL}/chat/financial-summary`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream' },
    body: JSON.stringify(body),
    signal,
  }),

  // Thread management
  getThreads: (userId = 'admin') =>
    fetch(`${AGENT_URL}/threads?user_id=${userId}&agent=financial-summary`).then(r => r.json()),
  getThread: (threadId, userId = 'admin') =>
    fetch(`${AGENT_URL}/threads/${threadId}?user_id=${userId}`).then(r => r.json()),
  getModels: () => fetch(`${AGENT_URL}/models`).then(r => r.json()),

  // Report CRUD
  listReports: (userId = 'admin') =>
    fetch(`${AGENT_URL}/reports?user_id=${userId}`).then(r => r.json()),
  getReport: (reportId, userId = 'admin') =>
    fetch(`${AGENT_URL}/reports/${reportId}?user_id=${userId}`).then(r => r.json()),
  saveReport: (body) =>
    fetch(`${AGENT_URL}/reports`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(r => r.json()),
  updateReport: (reportId, body) =>
    fetch(`${AGENT_URL}/reports/${reportId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(r => r.json()),
  deleteReport: (reportId, userId = 'admin') =>
    fetch(`${AGENT_URL}/reports/${reportId}?user_id=${userId}`, { method: 'DELETE' }).then(r => r.json()),

  // Data engine (reuse for company selector)
  getRealms: () =>
    fetch(`${window._env_?.REACT_APP_DATA_ENGINE_URL || 'http://localhost:8002'}/api/query/realms`).then(r => r.json()),
};
